if (!customElements.get('kr-lifestyle-carousel')) {
  customElements.define('kr-lifestyle-carousel', class extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('.kr-lifestyle__grid');
      this.cards = [...this.querySelectorAll('.kr-lifestyle__card')];
      this.dots = [...this.querySelectorAll('.kr-lifestyle__dot')];
      if (!this.grid || !this.cards.length) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.mobile = matchMedia('(max-width: 749px)');
      this.update = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const left = this.grid.getBoundingClientRect().left;
          let closest = 0;
          let distance = Infinity;
          this.cards.forEach((card, index) => {
            const d = Math.abs(card.getBoundingClientRect().left - left);
            if (d < distance) { closest = index; distance = d; }
          });
          // At the end the last card may not reach the leading edge.
          if (this.grid.scrollLeft > 0 && this.grid.scrollLeft >= this.grid.scrollWidth - this.grid.clientWidth - 2) closest = this.cards.length - 1;
          this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === closest)));
        });
      };
      this.go = (index) => {
        if (!this.mobile.matches) return;
        this.grid.scrollTo({
          left: this.cards[index].offsetLeft - this.cards[0].offsetLeft,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index), options));
      this.grid.addEventListener('scroll', this.update, { ...options, passive: true });
      window.addEventListener('resize', this.update, options);
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.cards.findIndex(card => card === event.target || card.contains(event.target));
        if (index >= 0) this.go(index);
      }, options);
      this.setAttribute('data-ready', '');
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      cancelAnimationFrame(this.frame);
    }
  });
}
